// API Configuration
export const API_BASE_URL = '/api';
export const SOCKET_URL = window.location.origin;
export const TIMEOUT = 30000;

// App Configuration
export const APP_CONFIG = {
  NAME: 'MatrimonyApp',
  DESCRIPTION: 'Professional Matrimonial Platform',
  VERSION: '1.0.0',
};

// User Roles
export const USER_ROLES = {
  USER: 'user',
  MARKETING: 'marketing',
  ADMIN: 'admin',
} as const;

// Subscription Plan Slugs
export const PLAN_SLUGS = {
  FREE: 'free',
  SILVER: 'silver',
  GOLD: 'gold',
  PLATINUM: 'platinum',
} as const;

// Blog Categories
export const BLOG_CATEGORIES = [
  { value: 'relationship_advice', label: 'Relationship Advice' },
  { value: 'wedding_planning', label: 'Wedding Planning' },
  { value: 'marriage_tips', label: 'Marriage Tips' },
  { value: 'dating_tips', label: 'Dating Tips' },
  { value: 'lifestyle', label: 'Lifestyle' },
  { value: 'success_stories', label: 'Success Stories' },
  { value: 'festivals', label: 'Festivals' },
  { value: 'fashion', label: 'Fashion' },
  { value: 'health', label: 'Health' },
  { value: 'other', label: 'Other' },
];

// Blog Status
export const BLOG_STATUS = {
  DRAFT: 'draft',
  PENDING: 'pending',
  PUBLISHED: 'published',
  REJECTED: 'rejected',
} as const;

// Gender Options
export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
];

// Marital Status Options
export const MARITAL_STATUS_OPTIONS = [
  { value: 'never_married', label: 'Never Married' },
  { value: 'divorced', label: 'Divorced' },
  { value: 'widowed', label: 'Widowed' },
  { value: 'separated', label: 'Separated' },
];

// Education Levels
export const EDUCATION_LEVELS = [
  { value: 'high_school', label: 'High School' },
  { value: 'diploma', label: 'Diploma' },
  { value: 'bachelors', label: "Bachelor's Degree" },
  { value: 'masters', label: "Master's Degree" },
  { value: 'phd', label: 'PhD/Doctorate' },
  { value: 'other', label: 'Other' },
];

// Employment Types
export const EMPLOYMENT_TYPES = [
  { value: 'government', label: 'Government' },
  { value: 'private', label: 'Private Sector' },
  { value: 'business', label: 'Business/Self-Employed' },
  { value: 'self_employed', label: 'Self-Employed' },
  { value: 'not_working', label: 'Not Working' },
];

// Annual Income Ranges
export const INCOME_RANGES = [
  { value: '0-3', label: '₹0 - ₹3 Lakhs' },
  { value: '3-5', label: '₹3 - ₹5 Lakhs' },
  { value: '5-7', label: '₹5 - ₹7 Lakhs' },
  { value: '7-10', label: '₹7 - ₹10 Lakhs' },
  { value: '10-15', label: '₹10 - ₹15 Lakhs' },
  { value: '15-20', label: '₹15 - ₹20 Lakhs' },
  { value: '20+', label: '₹20+ Lakhs' },
];

// Religion Options
export const RELIGION_OPTIONS = [
  { value: 'hindu', label: 'Hindu' },
  { value: 'muslim', label: 'Muslim' },
  { value: 'christian', label: 'Christian' },
  { value: 'sikh', label: 'Sikh' },
  { value: 'buddhist', label: 'Buddhist' },
  { value: 'jain', label: 'Jain' },
  { value: 'parsi', label: 'Parsi' },
  { value: 'jewish', label: 'Jewish' },
  { value: 'other', label: 'Other' },
  { value: 'no_religion', label: 'No Religion' },
];

// Diet Preferences
export const DIET_OPTIONS = [
  { value: 'vegetarian', label: 'Vegetarian' },
  { value: 'non_vegetarian', label: 'Non-Vegetarian' },
  { value: 'eggetarian', label: 'Eggetarian' },
  { value: 'vegan', label: 'Vegan' },
];

// Smoking/Drinking Habits
export const HABIT_OPTIONS = [
  { value: 'no', label: 'No' },
  { value: 'occasionally', label: 'Occasionally' },
  { value: 'yes', label: 'Yes' },
];

// Manglik Options
export const MANGLIK_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'anshik', label: 'Anshik (Partial)' },
  { value: 'dont_know', label: "Don't Know" },
];

// Mother Tongue Options
export const MOTHER_TONGUE_OPTIONS = [
  { value: 'Hindi', label: 'Hindi' },
  { value: 'English', label: 'English' },
  { value: 'Bengali', label: 'Bengali' },
  { value: 'Telugu', label: 'Telugu' },
  { value: 'Marathi', label: 'Marathi' },
  { value: 'Tamil', label: 'Tamil' },
  { value: 'Gujarati', label: 'Gujarati' },
  { value: 'Urdu', label: 'Urdu' },
  { value: 'Kannada', label: 'Kannada' },
  { value: 'Odia', label: 'Odia' },
  { value: 'Malayalam', label: 'Malayalam' },
  { value: 'Punjabi', label: 'Punjabi' },
  { value: 'Assamese', label: 'Assamese' },
  { value: 'Maithili', label: 'Maithili' },
  { value: 'Sanskrit', label: 'Sanskrit' },
  { value: 'Konkani', label: 'Konkani' },
  { value: 'Nepali', label: 'Nepali' },
  { value: 'Sindhi', label: 'Sindhi' },
  { value: 'Dogri', label: 'Dogri' },
  { value: 'Kashmiri', label: 'Kashmiri' },
  { value: 'Manipuri', label: 'Manipuri' },
  { value: 'Bodo', label: 'Bodo' },
  { value: 'Santali', label: 'Santali' },
  { value: 'Other', label: 'Other' },
];

// Height options (in cm)
export const HEIGHT_OPTIONS = Array.from({ length: 101 }, (_, i) => {
  const height = 120 + i;
  const feet = Math.floor(height / 30.48);
  const inches = Math.round((height % 30.48) / 2.54);
  return {
    value: height,
    label: `${height} cm (${feet}'${inches}")`
  };
});

// Family Type
export const FAMILY_TYPE_OPTIONS = [
  { value: 'joint', label: 'Joint Family' },
  { value: 'nuclear', label: 'Nuclear Family' },
];

// Family Status
export const FAMILY_STATUS_OPTIONS = [
  { value: 'middle_class', label: 'Middle Class' },
  { value: 'upper_middle_class', label: 'Upper Middle Class' },
  { value: 'rich', label: 'Rich' },
  { value: 'affluent', label: 'Affluent' },
];

// Family Values
export const FAMILY_VALUES_OPTIONS = [
  { value: 'traditional', label: 'Traditional' },
  { value: 'moderate', label: 'Moderate' },
  { value: 'liberal', label: 'Liberal' },
];

// Payment Methods
export const PAYMENT_METHODS = {
  RAZORPAY: 'razorpay',
  UPI: 'upi',
  CARD: 'card',
  NETBANKING: 'netbanking',
  WALLET: 'wallet',
} as const;

// Payment Status
export const PAYMENT_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  REFUNDED: 'refunded',
} as const;

// Order Status
export const ORDER_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
} as const;

// Commission Status
export const COMMISSION_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  PAID: 'paid',
  REJECTED: 'rejected',
} as const;

// Message Types
export const MESSAGE_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
  FILE: 'file',
} as const;

// Notification Types
export const NOTIFICATION_TYPES = {
  MATCH: 'match',
  INTEREST_RECEIVED: 'interest_received',
  INTEREST_ACCEPTED: 'interest_accepted',
  MESSAGE: 'message',
  PROFILE_VIEW: 'profile_view',
  SUBSCRIPTION: 'subscription',
  PAYMENT: 'payment',
  ADMIN: 'admin',
} as const;

// Date Formats
export const DATE_FORMATS = {
  SHORT: 'MMM DD, YYYY',
  LONG: 'MMMM DD, YYYY',
  DATETIME: 'MMM DD, YYYY HH:mm',
  TIME: 'HH:mm',
} as const;

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 20,
  MAX_LIMIT: 100,
};

// File Upload Limits
export const UPLOAD_LIMITS = {
  MAX_IMAGE_SIZE: 5 * 1024 * 1024, // 5MB
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'],
  ALLOWED_FILE_TYPES: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
};

// Coupon Configuration
export const COUPON_CONFIG = {
  MIN_DISCOUNT: 10,
  MAX_DISCOUNT: 90,
  DEFAULT_COMMISSION: 50, // 50% for marketing users
};

// Marketing User Configuration
export const MARKETING_CONFIG = {
  INACTIVITY_DAYS: 30,
  MIN_PAYOUT_AMOUNT: 500, // Minimum ₹500 for payout
  COMMISSION_PERCENTAGE: 50,
};

// Theme Colors
export const THEME_COLORS = {
  primary: '#E91E63',
  secondary: '#9C27B0',
  success: '#4CAF50',
  warning: '#FF9800',
  error: '#F44336',
  info: '#2196F3',
};

// Profile Completion Steps
export const PROFILE_STEPS = [
  { id: 'basic', label: 'Basic Information', weight: 20 },
  { id: 'contact', label: 'Contact Details', weight: 10 },
  { id: 'education', label: 'Education & Career', weight: 20 },
  { id: 'family', label: 'Family Details', weight: 15 },
  { id: 'lifestyle', label: 'Lifestyle', weight: 10 },
  { id: 'photos', label: 'Photos', weight: 15 },
  { id: 'preferences', label: 'Partner Preferences', weight: 10 },
];

// Search Filters
export const SEARCH_FILTERS = {
  AGE_MIN: 18,
  AGE_MAX: 80,
  HEIGHT_MIN: 120, // cm
  HEIGHT_MAX: 220, // cm
};

// Razorpay Configuration
export const RAZORPAY_CONFIG = {
  KEY_ID: (typeof import.meta.env !== 'undefined' && import.meta.env.VITE_RAZORPAY_KEY_ID) || '',
  CURRENCY: 'INR',
  NAME: 'MatrimonyApp',
  DESCRIPTION: 'Subscription Payment',
  IMAGE: '/logo.png',
  THEME_COLOR: '#E91E63',
};

// Socket Events
export const SOCKET_EVENTS = {
  // Connection
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  AUTHENTICATE: 'authenticate',
  AUTHENTICATED: 'authenticated',
  
  // Chat
  JOIN_CHAT: 'join_chat',
  LEAVE_CHAT: 'leave_chat',
  SEND_MESSAGE: 'send_message',
  NEW_MESSAGE: 'new_message',
  MESSAGE_DELETED: 'message_deleted',
  MESSAGES_READ: 'messages_read',
  
  // Typing
  TYPING_START: 'typing_start',
  TYPING_STOP: 'typing_stop',
  USER_TYPING: 'user_typing',
  USER_STOPPED_TYPING: 'user_stopped_typing',
  
  // Status
  USER_ONLINE: 'user_online',
  USER_OFFLINE: 'user_offline',
  ONLINE_USERS: 'online_users',
  
  // Notifications
  NOTIFICATION: 'notification',
  
  // Errors
  ERROR: 'error',
} as const;

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  THEME: 'theme',
  LANGUAGE: 'language',
  RECENT_SEARCHES: 'recent_searches',
  VIEWED_PROFILES: 'viewed_profiles',
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your internet connection.',
  UNAUTHORIZED: 'You are not authorized. Please login again.',
  NOT_FOUND: 'The requested resource was not found.',
  SERVER_ERROR: 'Server error. Please try again later.',
  VALIDATION_ERROR: 'Please check your input and try again.',
  UNKNOWN_ERROR: 'An unexpected error occurred.',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'Logged in successfully!',
  REGISTER_SUCCESS: 'Registration successful!',
  PROFILE_UPDATED: 'Profile updated successfully!',
  MESSAGE_SENT: 'Message sent successfully!',
  INTEREST_SENT: 'Interest sent successfully!',
  PAYMENT_SUCCESS: 'Payment completed successfully!',
  BLOG_SUBMITTED: 'Blog submitted successfully!',
};

// Regex Patterns
export const REGEX_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^[6-9]\d{9}$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  URL: /^https?:\/\/.+/,
  SLUG: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
};

export default {
  API_BASE_URL,
  APP_CONFIG,
  USER_ROLES,
  PLAN_SLUGS,
  BLOG_CATEGORIES,
  PAYMENT_METHODS,
  STORAGE_KEYS,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
};